import React from 'react';
import { UserPatchMutation } from '../graphql/mutations/UserPatchMutation';
import { UserEditQuery } from '../graphql/query/UserEditQuery';
import { EntityEditFetcher } from '../components/EntityEditFetcher';
import typeIntro from '../static/introspection/User.json';
import inputTypeIntro from '../static/introspection/UserPatchInput.json';
import { ENTITY } from '../utils/entities';
import { graphqlQuery } from '../utils/graphql';
import { UserData } from '@food/auth';

export const UserEdit = ({ id }) => (
	<UserData>
		{({ userHasCapability }) => (
			<EntityEditFetcher
				fetcher={graphqlQuery(UserEditQuery, { id })}
				mutation={UserPatchMutation}
				entityName={ENTITY.USER}
				typeIntro={typeIntro}
				inputTypeIntro={inputTypeIntro}
				id={id}
				fields={[
					!id || userHasCapability('ADMIN_EXTRA' as any)
						? 'sfId'
						: null,
					'firstName',
					'lastName',
					'role',
					'status',
					'Team',
					'internalCapabilities',
				]}
			/>
		)}
	</UserData>
);
